module.exports = __webpack_public_path__ + "img/logo-symbol.bf5f6846.svg";